/* BICH Consulting – Schnell-Hinzufügen für „Passt dazu“ und Warenkorb-Empfehlungen (ohne App) */
(function () {
  if (window.__bichUpsell) return;
  window.__bichUpsell = true;
  document.addEventListener('click', async function (e) {
    var b = e.target.closest('[data-bich-add],[data-bich-add-select]');
    if (!b) return;
    e.preventDefault();
    var id = b.getAttribute('data-bich-add');
    if (!id) {
      var s = b.parentElement.querySelector('select');
      id = s && s.value;
    }
    if (!id) return;
    var label = b.textContent;
    b.disabled = true;
    b.textContent = 'Wird hinzugefügt …';
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = !!document.querySelector('cart-items:not(cart-drawer-items)');
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    if (drawer && !onCartPage && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (x) { return x.id; });
      body.sections_url = window.location.pathname;
    }
    try {
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      var r = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || j.message || 'Fehler');
      b.textContent = '✓ Hinzugefügt';
      b.classList.add('bich-btn--done');
      if (onCartPage) { window.location.reload(); return; }
      if (drawer && j.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(j);
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (err) {
      b.textContent = 'Nicht möglich – bitte anfragen';
      setTimeout(function () { b.textContent = label; b.disabled = false; }, 2500);
    }
  });
})();
/* BICH Anfragekorb: früheres automatisches Entfernen von „Preis auf Anfrage“-Artikeln und Leeren des Gast-Warenkorbs entfernt – alle Besucher nutzen den Anfragekorb */

/* BICH Anfragekorb-Toast (nicht blockierend) */
window.bichToast = function (msg) {
  var t = document.getElementById('bich-toast');
  if (!t) {
    t = document.createElement('div'); t.id = 'bich-toast'; t.className = 'bich-toast';
    t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite');
    document.body.appendChild(t);
  }
  var url = (window.routes && window.routes.cart_url) || '/cart';
  t.innerHTML = '<span class="bich-toast__ico" aria-hidden="true">✓</span><span>' + (msg || 'Zum Anfragekorb hinzugefügt') + '</span> <a href="' + url + '">Anfragekorb ansehen</a><button type="button" class="bich-toast__x" aria-label="Hinweis schließen">×</button>';
  t.querySelector('.bich-toast__x').onclick = function () { t.classList.remove('is-on'); };
  t.classList.add('is-on');
  clearTimeout(window.__bichToastT);
  window.__bichToastT = setTimeout(function () { t.classList.remove('is-on'); }, 5000);
};
/* BICH Spamschutz: Honeypot + Mindest-Ausfüllzeit (3 s) für Anfrageformulare; läuft vor Shopifys hCaptcha (capture) und blockiert nur Verdachtsfälle */
(function () {
  var IDS = ['AnfragekorbForm', 'AngebotForm'], t0 = Date.now();
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || IDS.indexOf(f.id) < 0) return;
    var hp = f.querySelector('[data-bich-hp]');
    var start = Number(f.getAttribute('data-bich-t0')) || t0;
    var msg = null;
    if (hp && hp.value) msg = 'Die Anfrage konnte nicht gesendet werden.';
    else if (Date.now() - start < 3000) msg = 'Bitte prüfen Sie Ihre Angaben und senden Sie in einem Moment erneut.';
    if (!msg) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var m = f.querySelector('.bich-hp-msg');
    if (!m) { m = document.createElement('p'); m.className = 'bich-hp-msg'; m.setAttribute('role', 'alert'); var b = f.querySelector('[type=submit]'); (b && b.parentNode ? b.parentNode : f).appendChild(m); }
    m.textContent = msg;
  }, true);
  function mark() { IDS.forEach(function (id) { var f = document.getElementById(id); if (f && !f.getAttribute('data-bich-t0')) f.setAttribute('data-bich-t0', String(Date.now())); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark); else mark();
})();
